import store from '@/store'
import globals from '@/plugins/globals.js'

export default (to, from, next) => {
  // exit if we are allowing anonymous
  if (to.matched.some(record => record.meta.allowAnonymous)) {
    next()
    return
  }
  // exit if they are not authenticated
  if (!store.getters['auth/token']) {
    store.dispatch('auth/setPassthrough', to.path)
    console.log('Not Authenticated, going to Login')
    next(`/login`)
    return
  }

  // Check RAG Only user FIRST (before other role checks)
  const isRagOnlyUser = store.getters['auth/isRagOnly']

  if (isRagOnlyUser) {
    // Allow access to RAG page and logout
    const allowedPaths = ['/rag', '/logout']
    const isAllowedPath = allowedPaths.some(path => to.path.startsWith(path))

    if (!isAllowedPath) {
      console.log('RAG Only user attempting to access restricted page, redirecting to RAG')
      next('/rag')
      return
    }
    // If it's an allowed path for RAG user, continue
    next()
    return
  }

  // exit if they are not allowed by role
  if (!store.getters['auth/isAllowed'](to.path)) {
    console.log('Is Allowed, going Home')
    next('/')
    return
  }
  // exit if route disallowed for specific clients
  if (globals.isUK() &&
      to.name === 'ScanPro Assist' &&
      (!globals.isStGobain() && !globals.isGlass() && !globals.isMahle())) {
    if (globals.isUserProfileComplete === null || globals.isUserProfileComplete === 'false') {
      next('/user')
    } else {
      next('/')
    }
    return
  }
  // make user profile screen mandatory unless it's Mahle
  if (globals.isUK()) {
    if (globals.isMahle()) {
      next()
      return
    }
    if (to.name !== 'User Profile' &&
        (globals.isUserProfileComplete === null || globals.isUserProfileComplete === 'false')) {
      next('/user')
      return
    }
  }
  // allowed
  next()
}



// WEBPACK FOOTER //
// ./src/router/guard.js